//  Package imports  //
import PropTypes from "prop-types";

import { defineMessages, injectIntl } from "react-intl";

import ImmutablePureComponent from "react-immutable-pure-component";

import { Icon } from "flavours/glitch/components/icon";

const messages = defineMessages({
  localOnly: { id: "status.local_only", defaultMessage: "Only visible from your instance" },
});

class LocalOnlyIcon extends ImmutablePureComponent {

  static propTypes = {
    intl: PropTypes.object.isRequired,
  };

  render() {
    const { intl } = this.props;

    const label = intl.formatMessage(messages.localOnly);
    const localOnlyIcon = 'house-line';
    const icon = (<Icon
      className='status__local_only-icon'
      id={localOnlyIcon}
      title={label}
      aria-hidden='true'
    />);

    return icon;
  }

}

export default injectIntl(LocalOnlyIcon);
